import { AxiosRequestConfig } from 'axios';

import { apiClient } from '@/lib/api/client';

import { Cart } from '../types';

/**
 * Get user cart items
 */
export const getUserCart = async (
  options?: AxiosRequestConfig,
): Promise<Cart> => {
  return apiClient<Cart>(
    {
      method: 'GET',
      url: `/carts`,
    },
    options,
  );
};

/**
 * Add item to user cart
 */
export const addItemToCart = async (
  data: { productId: string; variantId: string },
  options?: AxiosRequestConfig,
) => {
  return apiClient(
    {
      method: 'POST',
      url: `/carts/items`,
      data,
    },
    options,
  );
};

/**
 * Remove item from user cart
 */
export const removeItemFromCart = async (
  itemId: string,
  options?: AxiosRequestConfig,
) => {
  return apiClient(
    {
      method: 'DELETE',
      url: `/carts/items/${itemId}`,
    },
    options,
  );
};
